import { render, staticRenderFns } from "./DeliveryTabs.vue?vue&type=template&id=59ac77c0&"
import script from "./DeliveryTabs.vue?vue&type=script&lang=js&"
export * from "./DeliveryTabs.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTabs.vue?vue&type=style&index=0&id=59ac77c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports